package com.macrofocus.eflux.ui.heatmap

import com.macrofocus.common.json.JsonArray
import com.macrofocus.common.units.Quantity
import com.macrofocus.eflux.network.Node
import com.macrofocus.eflux.network.NodeField
import js.objects.unsafeJso

public fun <N: Node> createNodeHeatmapData(
    nodes: Iterable<N>?,
    backgroundNodes: NodeField<*>?,
    getCoordiantes: (N) -> JsonArray?,
    normalized: Boolean,
) : Array<dynamic> {
    val list = ArrayList<dynamic>()
    if (nodes != null && backgroundNodes != null) {
        for (row : N in nodes) {
            val geom = getCoordiantes(row)
            if (geom != null) {
                val value: Any?
                if (normalized) {
                    value = backgroundNodes.getNormalized(row)
                } else {
                    value = backgroundNodes.getValue(row)
                }
                val amount: Double?
                if (value is Number) {
                    amount = value.toDouble()
                } else if (value is Quantity<*>) {
                    amount = value.amount
                } else {
                    amount = null
                }
                if (amount != null) {
                    val p = unsafeJso<dynamic> {
                        COORDINATES = geom
                        WEIGHT = amount
                    }
                    list.add(p)
                }
            }
        }
    }

    return list.toTypedArray()
}
